<template>
<div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Asignación de Certificados</h4>
            <p>Realiza la Busqueda y emision de Certificados a Empresas u Personas y Embarcaciones </p>       
        </div>
    </div>
    
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#search-owner" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Empresas u Personas</a>
            <a class="nav-item nav-link" id="nav-capitan-list" data-toggle="tab" href="#search-ship" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Embarcaciones</a>
            
        </div>
    </nav>
            
    <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="search-owner" role="tabpanel" aria-labelledby="nav-new-tab" >
            <br>
                    
                    <h6 align="center">Busqueda y Seleccion de Propietario(s) u Empresa</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="person_select.id > 0" class="panel panel-default">
                        <h6 align="left">Registro Anterior</h6>
                        <hr>
                        <table class="table sm">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Persona/Empresa</th>
                                <th>Certificado</th>
                                <th>Imprimir</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="cold, index in certificatesOldOwner" :key="cold.id">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ cold.nombre_propietario }}</td>
                                    <td>{{ cold.type_certificate }}</td>
                                    <td><button class="btn btn-success" @click="mReportCertificates(cold.id_certificate, cold.id_person_owner)"><font-awesome-icon icon="file-pdf" /></button></td>
                                </tr>
                            </tbody>
                        </table>
                        <h6 align="left">Nuevo Registro</h6>
                        <hr>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Nombre Completo</label>
                                <input type="text" name="name_owner" id="name_owner" readonly class="form-control-plaintext" :value="person_select.name">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                                <input type="text" class="form-control-plaintext" :value="person_select.number_identification" name="number_identification" readonly>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="site_expedition" class="badge badge-primary">Telefono </label>
                                <input type="text" class="form-control-plaintext" :value="person_select.phone" name="number_identification" readonly>
                            </div>
                        </div>

                        <!-- aqui debe ir si ya tiene registrado algun certificado que indique -->
                        <div class="form-row">
                            <div class="input-group col-12 col-md-4">
                                <div class="input-group-append">
                                    <span class="input-group-text">Categoria</span>
                                </div>
                                <select name="type_cert" id="type_cert" class="form-control" v-model="dts_certificate_one.category">
                                    <option v-for="co in categorys_owner" :key="co.id" :value="co.id">{{co.detail}}</option>
                                </select>
                            </div>
                            <div class="input-group col-12 col-md-4">
                                <div class="input-group-append">
                                    <span class="input-group-text">Tipo Registro</span>
                                </div>
                                <select name="type_cert" id="type_cert" class="form-control" v-model="dts_certificate_one.type_register">
                                    <option v-for="tc in types_certificado" :key="tc.id" :value="tc.id">{{tc.detail}}</option>
                                </select>
                            </div>
                            <div class="input-group col-12 col-md-4">
                                <div class="input-group-append">
                                    <span class="input-group-text">Fecha Expedición</span>
                                </div>
                                <input type="date" name="date_expedition" id="date_expedition" class="form-control" autocomplete="off" v-model="dts_certificate_one.date_expedition">
                            </div>
                        </div>
                        <br>                        

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="enroll_uumm">Tipo Certificado</label>
                                <select name="type_fr" id="type_fr" class="form-control" v-model="temp_certificate_temp" @change="mGetLastFirmaOwner($event)">
                                    <option v-for="tcr in type_certificado_reg" :key="tcr.id" :value="tcr">{{tcr.detail}}</option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="enroll_uumm">Sector</label>
                                <select name="type_sector" id="type_sector" class="form-control" v-model="dts_certificate_one.sector">
                                    <option v-for="ts in types_sectores" :key="ts.id" :value="ts.id">{{ts.detail}}</option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="enroll_uumm">Número de Matricula</label>
                                <input type="text" name="Matricula" id="enroll_uumm" class="form-control" placeholder="100" autocomplete="off" v-model="dts_certificate_one.number_matricula" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="enroll_uumm">Libro</label>
                                <input type="text" name="libro" id="book_uumm" class="form-control" placeholder="1 'A' " autocomplete="off" v-model="dts_certificate_one.book"/>
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="enroll_uumm">Fojas</label>
                                <input type="text" name="libro" id="book_uumm" class="form-control" placeholder="003 - 004" autocomplete="off" v-model="dts_certificate_one.fojas" />
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="enroll_uumm">Partida</label>
                                <input type="text" name="libro" id="book_uumm" class="form-control" placeholder="002" autocomplete="off" v-model="dts_certificate_one.partida" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="enroll_uumm">Responsable de Registro</label>
                                <input type="text" name="libro" id="book_uumm" class="form-control" placeholder="CC. CGONMC. XXXXXX" autocomplete="off" v-model="dts_certificate_one.firma_one" />
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="enroll_uumm">Jefe Unidad de Marina Mercante</label>
                                <input type="text" name="libro" id="book_uumm" class="form-control" placeholder="CC. CGONMC. XXXXXX" autocomplete="off" v-model="dts_certificate_one.firma_secondary" />
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <label for="enroll_uumm">Director General</label>
                                <input type="text" name="libro" id="book_uumm" class="form-control" placeholder="CN. DAEN. XXXXXXX" autocomplete="off" v-model="dts_certificate_one.firma_principal"/>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <select name="type_sector" id="type_sector" class="form-control" v-model="dts_certificate_one.firm_one">
                                    <option v-for="cs in charges_um" :key="cs.id" :value="cs.id">{{cs.detail}}</option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <select name="type_sector" id="type_sector" class="form-control" v-model="dts_certificate_one.firm_second">
                                    <option v-for="cs in charges_um" :key="cs.id" :value="cs.id">{{cs.detail}}</option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-md-4">
                                <select name="type_sector" id="type_sector" class="form-control" v-model="dts_certificate_one.firm_principal">
                                    <option v-for="cp in charges_um" :key="cp.id" :value="cp.id">{{cp.detail}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="input-group col-12 col-md-6">
                                <div class="input-group-append">
                                    <span class="input-group-text">Numero Permiso (Permiso Operaciones)</span>
                                </div>
                                <input type="text" name="number_permiss" id="number_permiss" class="form-control" autocomplete="off" v-model="dts_certificate_one.number_permiss">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label for="enroll_uumm">Detalle (Permiso de Operaciones)</label>
                                <textarea cols="50" rows="5" name="libro" id="detail_optional" class="form-control" placeholder="Por lo tanto, a partir de la Fecha ....." autocomplete="off" v-model="dts_certificate_one.detail_optional" ></textarea>
                            </div>
                        </div>

                        <button class="btn btn-success col-12 col-md-2 offset-md-4" @click="mSaveCertificatePerson"><font-awesome-icon icon="check-square" size="2x" /></button>
                        <button class="btn btn-danger col-12 col-md-2" @click="mCloseSelectPerson"><font-awesome-icon icon="times-circle" size="2x" /></button>

                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearchPerson">
                                <input class="form-check-input" type="radio" name="personSearch" id="personSearch1" v-model="optionSearchPerson" value="document" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearchPerson">
                                <input class="form-check-input" type="radio" name="personSearch" id="personSearch2" v-model="optionSearchPerson" value="name">No. Documento
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombrePersona">{{ searchTypePerson }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_person" :placeholder="searchTypePerson" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypePerson }} </small>
                        </div>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaDataPerson">Buscar</button>

                        <div class="table-responsive" v-if="list_person_select.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre Completo</th>
                                        <th>CI / NIT</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(persSelc, index) in list_person_select" :key="persSelc.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ persSelc.nombre_propietario }}</span>
                                        </td>
                                        <td>{{ persSelc.dato_identificacion }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectPersonOwner(persSelc)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>

        </div>
        <!-- end first tab -->

        <div class="tab-pane fade" id="search-ship" role="tabpanel" aria-labelledby="nav-new-tab" >
            <br>
                    
                    <h6 align="center">Busqueda y Seleccion de Embarcacion/Nave/Artefacto Naval</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="ship_select_uumm.id > 0" class="panel panel-default">
                        <button class="btn btn-success col-12 col-md-4 offset-md-4" @click="mCallPrint(ship_select_uumm.id)">Caracteristicas <font-awesome-icon icon="file-pdf" /></button>
                        <br>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Nombre Embarcación</label>
                                <input type="text" name="name_owner" id="name_owner" readonly class="form-control-plaintext" :value="ship_select_uumm.name_boat">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select_uumm.enrollment_old" name="number_identification" readonly>
                            </div>

                            <div class="form-group col-12 col-md-2">
                                <label for="site_expedition" class="badge badge-primary">TRB </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select_uumm.trb" name="number_identification" readonly>
                            </div>
                            <div class="form-group col-12 col-md-2">
                                <label for="site_expedition" class="badge badge-primary">TRN </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select_uumm.trn" name="number_identification" readonly>
                            </div>
                        </div>
                        <hr>
                        <button class="btn btn-info" @click="mCallCertificatesRegisterShip">Listar Certificados</button><button class="btn btn-success" @click="mUpdateStateShips">Actualizar Estados</button>
                        <h5>Certificados Registrados</h5>
                        <table class="table table-sm" v-if="list_certificates_ships.length>0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Certificado</th>
                                    <th>Registro</th>
                                    <th>Vencimiento</th>
                                    <th>Reporte</th>
                                    <th>Renovar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for=" (lcs, index) in list_certificates_ships" :key="lcs.id_certificado">
                                    <td>{{index+1}}</td>
                                    <td>{{ lcs.descripcion_certificado }}</td>
                                    <td>{{ lcs.numero_registro }}</td>
                                    <td class="alert" :class="lcs.estado_registro==='A'? 'alert-success':'alert-danger' ">{{ lcs.short_detail==='T'? lcs.fecha_vencimiento: 'INDEFINIDO' }}</td>
                                    <td><button class="btn btn-success" @click="mReportCertificatesShips(lcs.id_certificado, lcs.id_certificacion)"><font-awesome-icon icon="file-pdf" /></button></td>
                                    <td>
                                        <button class="btn btn-info" @click="mUpdateVigency(lcs.id_certificado, lcs.id_certificacion)" v-if="lcs.short_detail==='T' ">Renovar</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <hr>
                        <h5>Nuevo Registro</h5>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="year_exec">Seleccion Certificado(s)</label>
                                <multiselect v-model="ship_uumm_reg.certificado" :options="certificatesShips" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Seleccion Certificado(s)" label="title" track-by="id" :selectLabel="options_select.selectLabel" :selectedLabel="options_select.selectedLabel" :deselectLabel="options_select.deselectLabel" :disabled="is_disabled">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} certificado(s) seleccionado(s)</span></template>
                                </multiselect>                        
                            </div>
                            <transition name="fade" mode="out-in">
                            <div class="form-group col-12 col-md-4" v-if="ship_uumm_reg.certificado.length > 0">
                                <label for="month-select">Certificado(s) Seleccionado(s)</label>
                                <div>
                                    <h5><span class="badge badge-success" v-for="cr in ship_uumm_reg.certificado" :key="cr.id"> {{ cr.title }} </span></h5>
                                </div>
                            </div>
                            </transition>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-2 offset-md-3">
                                <label for="enroll_uumm">Sector</label>
                                <select name="type_sector" id="type_sector" class="form-control" v-model="ship_uumm_reg.sector">
                                    <option v-for="ts in types_sectores" :key="ts.id" :value="ts.id">{{ts.detail}}</option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-md-2">
                                <label for="registro" class="badge badge-primary">Número de Registro</label>
                                <input type="number" min="1" autocomplete="off" v-model="ship_uumm_reg.registro" class="form-control">
                            </div>
                            <div class="form-group col-12 col-md-2">
                                <label for="type_certificate" class="badge badge-primary">Servicios de la Embarcación</label>
                                <input type="text" autocomplete="off" v-model="ship_uumm_reg.servicio" class="form-control">
                            </div>
                            
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-3">
                                <label for="francobordo">Francobordo</label>
                                <input type="number" class="form-control" autocomplete="off" v-model="ship_uumm_reg.francobordo">
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="peso_altura">Peso y Altura de la Cubertada</label>
                                <input type="text" class="form-control" autocomplete="off" id="peso_altura" v-model="ship_uumm_reg.cubertada">
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="mercancia_pel">Mercancia Peligrosa</label>
                                <select class="form-control" name="mercancia_pel" id="mercancia_pel" v-model="ship_uumm_reg.mercancias">
                                    <option value="S">SI</option>
                                    <option value="N">NO</option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="francobordo">Número Max. Pasajeros</label>
                                <input type="number" class="form-control" autocomplete="off" v-model="ship_uumm_reg.pasajeros">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-3">
                                <label for="francobordo">Potencia Electrica Nominal Continua</label>
                                <input type="number" id="potencia" name="potencia" class="form-control" autocomplete="off" v-model="ship_uumm_reg.potencia_electrica_continua">
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="francobordo">Potencia Electrica Nominal Alterna</label>
                                <input type="number" id="potencia_alterna" name="potencia" class="form-control" autocomplete="off" v-model="ship_uumm_reg.potencia_electrica_alterna">
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="francobordo">Puerto de Registro</label>
                                <input type="text" id="puerto_registro" name="potencia" class="form-control" autocomplete="off" v-model="ship_uumm_reg.puerto_registro">
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="francobordo">Fecha de Inspección</label>
                                <input type="date" id="puerto_registro" name="potencia" class="form-control" autocomplete="off" v-model="ship_uumm_reg.fecha_inicio">
                            </div>
                        </div>
                        <br>
                        <button class="btn btn-success col-12 col-md-2 offset-md-4" @click="mRegisterShipUUMM"><font-awesome-icon icon="save" size="2x" /></button>
                        <button class="btn btn-danger col-12 col-md-2" @click="mCloseSelectShip"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearchShip">
                                <input class="form-check-input" type="radio" name="radiosShip" id="radiosShip1" v-model="optionSearchShip"  value="enrollment" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearchShip">
                                <input class="form-check-input" type="radio" name="radiosShip" id="radiosShip2" v-model="optionSearchShip" value="name">Matricula
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombrePersona">{{ searchTypeShip }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_ship" :placeholder="searchTypeShip" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypeShip }} </small>
                        </div>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaDataShip">Buscar</button>

                        <div class="table-responsive" v-if="list_ship_select.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre</th>
                                        <th>MATRICULA</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(shipSelc, index) in list_ship_select" :key="shipSelc.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ shipSelc.name_boat }}</span>
                                        </td>
                                        <td>{{ shipSelc.enrollment_old }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectShipOwner(shipSelc)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
        </div>

    </div>
    <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
    <modal-report :id-modal-report="id_modal_r" :title="modal_report_t" :content="modal_report_c" :url-r="modal_report_url" :id-report="id_report"></modal-report>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
const qs = require('qs');

import modalLoading from '../modal/modalLoading';
import modalReport from '../modal/modalReport.vue';

export default {
    name:'uumm-sign',
    data(){
        return{
            list_certificates_ships:[],
            ship_uumm_reg:{
                id:0, 
                certificado:[],
                servicio:'',
                francobordo:0,
                registro:'',
                potencia_electrica_continua:0,
                potencia_electrica_alterna:0,
                cubertada:0,
                mercancias:'',
                pasajeros:0,
                numero_motor:'',
                puerto_registro:'',
                sector:0,
                fecha_inicio:''
            },
            id_modal_r:'reportuumm',
            modal_report_t:'Certificados UUMM',
            modal_report_url:'pdfuumm',
            id_report:0,
            modal_report_c:null,
            description_transfer:null,
            owner:{},
            person_select:{id:0},
            list_person_select:[],
            ship_select_uumm:{id:0},
            list_ship_select:[],
            types_identification:[],
            citys:[],
            countrys:[],
            status_send:true,
            modal_load_id:'id_owner_new',
            modal_load_title:'Registrando', 
            optionSearchShip:'name',
            optionSearchPerson:'name',
            data_person:null,
            data_ship:null,
            optionSearch:'name',
            old_owner:{id:0},
            dts_transfer:null,
            types_certificado:[],
            categorys_owner:[],
            types_sectores:[],
            type_certificado_reg:[],
            charges_um:[],
            last_register_person:[],
            dts_certificate_one:{
                id_person:0,
                type_register:0,
                type_certificate:0,
                sector:0,
                number_matricula:'',
                book:'',
                fojas:'',
                partida:'',
                firma_one:'',
                firma_secondary:'',
                firma_principal:'',
                firm_one:0,
                firm_second:0,
                firm_principal:0,
                detail_optional:'',
                category:0,
                date_expedition:'',
                date_conclusion:'',
                number_permiss:'',
                type_validate:''
            },
            certificatesOldOwner:[],
            certificatesShips:[],
            temp_certificate_temp:{id:0},
            options_select:{
                selectLabel:'Seleccionar',
                selectedLabel:'Seleccionado',
                deselectLabel:'Deseleccionar'
            },
            is_disabled:false
        }
    },
    mounted(){
        // if(Vue.auth.getToken()){
        //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
        // }
        // console.log(axios.defaults.headers)
        this.mCallTipos();
    },
    methods:{
        mUpdateVigency(certificado, id){
            // aqui colocamos la opcion de colocar la fecha
            let message = {
                    title: 'Actualizacion Vigencia del Certificado',
                    body: `Indique la nueva fecha de inicio de validez de la matricula`
                }
                let options ={
                    promptHelp:'Digite la fecha de Inicio Validez "dd/mm/aaaa" '
                }
            // console.log(`el id de boat es ${e}`);
            this.codeAutorization=null;
            let nca=new Promise((resolve, reject)=>{
                this.$dialog
                .prompt(message, options)
                .then(dialog => {
                    // Triggered when proceed button is clicked
                    // Show an alert with the user's input as the message
                    this.codeAutorization=dialog.data ? dialog.data : null
                    // this.$dialog.alert(dialog.data || '[empty]')
                    resolve(this.codeAutorization);
                })
                .catch(() => {
                    // Triggered when dialog is dismissed by user
                
                    console.log('peticion rechazada');
                    toastr.warning('No se ha enviado la peticion', 'Advertencia')
                });
            })
                
            nca.then( async (code)=>{
                if(code){
                    let dtAux=this.$dateConverse(code);
                    console.log(dtAux);
                    dtAux=dtAux.split("T");
                    let auxUpdateCert={
                        id:id,
                        certificado:certificado,
                        fecha_inicio:dtAux[0]
                    }
                    // activamos el loading de envio codigo
                    let updc=await axios.post(`updateCertificateUUMMSHip?api_token=${Vue.auth.getToken()}`, qs.stringify(auxUpdateCert));
                    let rp = updc.data[0];
                    // console.log(rp);
                    if(rp.status){
                        toastr.success(rp.respuesta);
                    }else{
                        toastr.warning(rp.respuesta);
                    }
                    
                }else{
                    console.error('no hay codigo')
                    toastr.error('Indique la nueva fecha', 'Error')
                }
            })
        },
        async mUpdateStateShips(){
            let updtShips=await axios.get(`getUpdateStateShipsMM?api_token=${Vue.auth.getToken()}`);
            if(updtShips.data[0].status){
                toastr.success(updtShips.data[0].respuesta);
            }else{
                toastr.success(updtShips.data[0].respuesta);
            }
        },
        async mCallCertificatesRegisterShip(){
            let callList=await axios.get(`callCertificadosShips/${this.ship_select_uumm.id}?api_token=${Vue.auth.getToken()}`);
            // console.log(callList);
            this.list_certificates_ships=callList.data;
        },
        mValidateRegisterShip(){
            // if(this.ship_uumm_reg.id===0){
            //     toastr.warning("Seleccione una Embarcacion a Registrar")
            //     return false;
            // }
            if(this.ship_uumm_reg.certificado.length===0){
                toastr.warning("Seleccione un tipo de Certificado Minimamente")
                return false;
            }
            if(this.ship_uumm_reg.sector===0){
                toastr.warning("Seleccione el sector correspondiente de trabajo de la Embarcación")
                return false;
            }
            if(this.ship_uumm_reg.registro.trim()===''){
                toastr.warning("Indique el Numero de Registro a incluir a la Embarcacion")
                return false;
            }
            if(this.ship_uumm_reg.servicio.trim()===''){
                toastr.warning("Indique el servicio al cual esta empeñada la Embarcacion")
                return false;
            }
            if(this.ship_uumm_reg.francobordo===0){
                toastr.warning("Indique el registro de francobordo")
                return false;
            }
            if(this.ship_uumm_reg.cubertada=0){
                toastr.warning("Indique el servicio al cual esta empeñada la Embarcacion")
                return false;
            }
            if(this.ship_uumm_reg.mercancias.trim()===''){
                toastr.warning("Indique si la Embarcacion trabaja con mercancias peligrosas")
                return false;
            }
            if(this.ship_uumm_reg.pasajeros=0){
                toastr.warning("Indique el numero de Pasajeros de la Embarcación")
                return false;
            }
            if(this.ship_uumm_reg.puerto_registro.trim()===''){
                toastr.warning("Indique el puerto en el cual se realiza el registro")
                return false;
            }
            if(this.ship_uumm_reg.fecha_inicio.trim()===''){
                toastr.warning("Indique la fecha de inicio de Inspección")
                return false;
            }
            return true;    
        },
        mRegisterShipUUMM(){
            if(this.mValidateRegisterShip()){
            let message = {
                    title: 'Registro de Certificados',
                    body: `¿Desea Registrar los Certificados Seleccionados, para la Embarcación <b>${this.ship_select_uumm.name_boat}</b> con Matrícula <b>${this.ship_select_uumm.enrollment_old}</b>?`
                };
            // validar que los datos esten completos

            let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos y validamos el presupuesto general en la bd
                        try {
                            this.ship_uumm_reg.id=this.ship_select_uumm.id;
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            // console.log('enviando al servidor')
                            // console.log(this.ship_uumm_reg.certificado);        
                            let r_certi_mm=await axios.post(`registerCertMMShips?api_token=${Vue.auth.getToken()}`, qs.stringify(this.ship_uumm_reg));

                            if(r_certi_mm.data[0].status){
                                toastr.success(r_certi_mm.data[0].respuesta);
                                // this.mChargeOldCertificates(this.person_select.id);
                                this.ship_uumm_reg.certificado='';
                                this.mCallCertificatesRegisterShip();
                                // this.mClearFormOwner();
                            }else{
                                toastr.error(r_certi_mm.data[0].respuesta);

                            }

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso de registro de Certificados', 'Error')
                                this.btn_r_ordop = false;
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.dts_ordop);
                    }
                })
            }
        },
        async mCallTipos(){
            let registros=await axios.get(`globals/reg_um?api_token=${Vue.auth.getToken()}`);
            let sector=await axios.get(`globals/basin?api_token=${Vue.auth.getToken()}`);
            let certificado_reg=await axios.get(`globals/cert_reg_um_owner?api_token=${Vue.auth.getToken()}`);
            let certificado_reg_ship=await axios.get(`globals/cert_reg_um?api_token=${Vue.auth.getToken()}`);
            let chargs=await axios.get(`globals/charge_um?api_token=${Vue.auth.getToken()}`);
            let catow=await axios.get(`globals/categoryown_um?api_token=${Vue.auth.getToken()}`);
            
            // console.log(registros)
            // console.log(sector)
            // console.log(certificado_reg)
            this.categorys_owner=catow.data;
            this.types_certificado=registros.data;
            this.types_sectores=sector.data;
            this.type_certificado_reg=certificado_reg.data;
            
            this.certificatesShips=[];
            certificado_reg_ship.data.forEach(dt=>{
                let item={
                    id:dt.id,
                    title:dt.detail
                }
                this.certificatesShips.push(item);  
            })

            this.charges_um=chargs.data;
        },
        async mGetLastFirmaOwner(event){
            // console.log(event);
            // console.log(event.target.value[0].id);

            // let certificate=event.target.value;
            let certificate=this.temp_certificate_temp.id;

            let firmLast=await axios.get(`getLastFirmOwner/${certificate}?api_token=${Vue.auth.getToken()}`);
            console.log(firmLast);
            if(firmLast.data.length>0){
                this.dts_certificate_one.firma_secondary=firmLast.data[0].firma_second;
                this.dts_certificate_one.firma_principal =firmLast.data[0].firma_primary;
                this.dts_certificate_one.firma_one=firmLast.data[0].firma_one;
                this.dts_certificate_one.detail_optional=firmLast.data[0].detail_optional;
            }
        },
        mValidateCertificatePerson(){
            if(this.dts_certificate_one.type_register===0){
                toastr.warning('Seleccione un tipo de Registro', 'Error');
                return false;
            }
            if(this.dts_certificate_one.category===0){
                toastr.warning('Seleccione una Categoria para el Registro', 'Error');
                return false;
            }
            if(this.dts_certificate_one.date_expedition.trim().length ===0){
                toastr.warning('Seleccione la fecha de Expedición', 'Error');
                return false;
            }
            
            this.dts_certificate_one.type_certificate=this.temp_certificate_temp.id;
            this.dts_certificate_one.type_validate=this.temp_certificate_temp.short_detail;

            if(this.dts_certificate_one.type_certificate===0){
                toastr.warning('Seleccione un tipo de Certificado', 'Error');
                return false;
            }
            if(this.dts_certificate_one.sector === 0){
                toastr.warning('Seleccione un Sector a Emitir el Certificado', 'Error');
                return false;
            }
            if(this.dts_certificate_one.number_matricula.trim().length ===0){
                toastr.warning('Indique el número de Matricula', 'Error');
                return false;
            }
            if(this.dts_certificate_one.book.trim().length ===0){
                toastr.warning('Indique el LIbro de Registro', 'Error');
                return false;
            }
            if(this.dts_certificate_one.fojas.trim().length ===0){
                toastr.warning('Indique las Fojas de Registro', 'Error');
                return false;
            }
            if(this.dts_certificate_one.partida.trim().length ===0){
                toastr.warning('Indique la partida', 'Error');
                return false;
            }
            if(this.dts_certificate_one.firma_secondary.trim().length ===0){
                toastr.warning('Indique el Nombre de la Firma Secundaria', 'Error');
                return false;
            }
            if(this.dts_certificate_one.firma_principal.trim().length ===0){
                toastr.warning('Indique el Nombre de la Firma Principal', 'Error');
                return false;
            }
            if(this.dts_certificate_one.firm_second ===0){
                toastr.warning('Seleccione el cargo de la firma secundaria', 'Error');
                return false;
            }
            if(this.dts_certificate_one.firm_principal ===0){
                toastr.warning('Seleccione el cargo de la Firma Principal', 'Error');
                return false;
            }
            if(this.dts_certificate_one.detail_optional.trim().length === 0){
                toastr.warning('Debe describir la conclusión', 'Error');
                return false;
            }
            return true;
        },
        async mSaveCertificatePerson(){
            // console.log(this.dts_certificate_one);
            if(this.mValidateCertificatePerson()){
                let message = {
                    title: 'Registro de Certificado',
                    body: `¿Desea realizar el registro para ${this.person_select.name}, anulando todos los registros anteriores existentes?`
                }
                // let aid=id;
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                // this.select_ordop=false;
                // this.mResetFormProcesOrdop();
                
                npr.then(async (msg)=>{
                    if(msg){
                        try {
                            // console.log(this.dts_certificate_one);
                            this.dts_certificate_one.id_person=this.person_select.id;
                            let reg_certificate = await axios.post(`insertCertificateUM?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_certificate_one))
                            if(reg_certificate.data.status){
                                toastr.success(reg_certificate.data.respuesta);
                                this.mChargeOldCertificates(this.person_select.id);
                                this.mClearFormOwner();
                            }    
                        } catch (error) {
                            console.error(error);    
                        }
                        
                    }else{
                        console.log('no se ha registrado el certificado')
                    }
                    // console.log(reg_certificate);
                })

            }
        },
        mClearFormOwner(){
            
            this.dts_certificate_one.type_register=0;
            this.dts_certificate_one.type_certificate=0;
            this.dts_certificate_one.sector=0;
            this.dts_certificate_one.number_matricula='';
            this.dts_certificate_one.book='';
            this.dts_certificate_one.fojas='';
            this.dts_certificate_one.partida='';
            this.dts_certificate_one.detail_optional='';
            
        },
        mShowModalUP(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalUP(idM){
            $('#'+idM).modal('hide');
        },
        mValidateDescriptionChange(){
            try {
                let auxDescription=this.description_transfer.trim();
                if(this.description_transfer===null || auxDescription.length===0){
                    toastr.error('Indique los documentos que sustentan la transferencia', 'Error P-01');
                    return false;
                }
                return true;    
            } catch (error) {
                console.log('error ')
            }
            
        },
        mViewSearchShip(event){
            // console.log(event);
            let radios=$("input[type=radio]").parent('label');
            console.log(radios);
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            // console.log(radioV);
            this.optionSearchShip=radioV;
        },
        mViewSearchPerson(event){
            console.log(event);
            let radios=$("input[type=radio]").parents('label');
            console.log(radios);
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            console.log(radioV);
            this.optionSearchPerson=radioV;
        },
        mCloseSelectPerson(){
            this.person_select.id=0;
            this.person_select.type_identification=0;
            this.person_select.number_identification=0;
            this.person_select.site_expedition=0;
            this.person_select.name=null;
            this.person_select.direction=null;
            this.person_select.mobile=null;
            this.person_select.phone=null;
            this.person_select.partner=null;
            this.person_select.nationality=0;
        },
        async mChargeOldCertificates(id_owner){
            let registrosOld=await axios.get(`getCertificatesPersonUM/${id_owner}?api_token=${Vue.auth.getToken()}`);
            this.certificatesOldOwner=registrosOld.data;
        },
        mSelectPersonOwner(sp){
            this.person_select.id=sp.id_propietario;
            this.person_select.type_identification=sp.tipo_identificacion;
            this.person_select.number_identification=sp.dato_identificacion;
            this.person_select.site_expedition=sp.id_expedido;
            this.person_select.name=sp.nombre_propietario;
            this.person_select.direction=sp.domicilio;
            this.person_select.mobile=sp.celular;
            this.person_select.phone=sp.telefono_fijo;
            this.person_select.partner=sp.representante_legal;
            this.person_select.nationality=sp.id_nacionalidad;
            // this.mChangeOwnerIdentificationEdit();
            this.mChargeOldCertificates(sp.id_propietario);
        },
        buscaDataPerson(){
            // console.log(`${this.optionSearch} tipo`);
            // console.log(`${this.data_person}`);
            if(this.data_person !== null || this.data_person.trim().length > 0 ){
                console.log('enviando al servidor');
                axios.get(`searchOwnerType/${this.data_person}/${this.optionSearchPerson}?api_token=${Vue.auth.getToken()}`)
                    .then((res) => {                    
                        this.list_person_select = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }else{
                toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
            }
        },
        buscaDataShip(){
            this.list_ship_select=[];
            // console.log(`${this.optionSearch} tipo`);
            // console.log(`${this.data_person}`);
            if(this.data_ship !== null || this.data_ship.trim().length > 0 ){
                // console.log('enviando al servidor');
                axios.get(`searchNameBoat/${this.optionSearchShip}/${this.data_ship}?api_token=${Vue.auth.getToken()}`)                
                .then((res) => {                    
                        this.list_ship_select = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }else{
                toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
            }
        },
        mCloseSelectShip(){
            this.ship_select_uumm.id=0;
            this.ship_select_uumm.name_boat=null;
            this.ship_select_uumm.enrollment=null;
            this.ship_select_uumm.enrollment_old=null;
            this.ship_select_uumm.trb=null;
            this.ship_select_uumm.trn=null;
            this.old_owner.id=0;
            this.old_owner.name=null;
            this.old_owner.documento=null;
        },
        mSelectShipOwner(sbp){
            this.ship_select_uumm.id=sbp.id_boat;
            this.ship_select_uumm.name_boat=sbp.name_boat;
            this.ship_select_uumm.enrollment=sbp.enrollment;
            this.ship_select_uumm.enrollment_old=sbp.enrollment_old;
            this.ship_select_uumm.trb=sbp.trb;
            this.ship_select_uumm.trn=sbp.trn;
            this.old_owner.id=sbp.id_propietario;
            this.old_owner.name=sbp.nombre_propietario;
            this.old_owner.documento=sbp.dato_identificacion;
            this.mCallCertificatesRegisterShip();
            // this.mChangeOwnerIdentificationEdit();
        },
        mReportCertificates(certificado, id){
            // console.log(`el certificado es ${certificado}, el id es ${id}`);
            this.modal_report_url=`pdfUUMM/${certificado}`;
            this.id_report=id;
            this.mShowModalUP(this.id_modal_r);
            this.mCloseModalUP(this.idModalL);            
        },
        mReportCertificatesShips(certificado, id){
            // console.log(`el certificado es ${certificado}, el id es ${id}`);
            this.modal_report_url=`pdfUUMMShip/${certificado}`;
            this.id_report=id;
            this.mShowModalUP(this.id_modal_r);
            this.mCloseModalUP(this.idModalL);            
        },
        mCallPrint(idb){
            // this.modalLoadTitle='Solicitando';
            // this.mShowModalRec(this.modalPro);
            this.id_report=idb;
            this.modal_report_url=`pdfReportBoat`;
            this.mShowModalUP(this.id_modal_r);
            this.mCloseModalUP(this.idModalL);
                        
        }
    },
    components:{
        'modal-loading':modalLoading,
        'modal-report':modalReport
    },
    computed:{
        searchTypeShip(){
            switch(this.optionSearchShip){
                case 'name':
                    return 'Nombre de la Nave';
                break;

                case 'enrollment':
                    return 'Matricula de la Nave';
                break;
            }
        },
        searchTypePerson(){
            switch(this.optionSearchPerson){
                case 'name':
                    return 'Nombre de la Persona';
                break;

                case 'document':
                    return 'Cedula de la Persona';
                break;
            }
        }
    },
    filters:{
        upperCase(value){
            return value.toUpperCase();
        }
    }
}
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
textarea{
    resize: none;
}
.my-scroll {
    width: 600px;
    height: 100px;
    padding: 5px;
    border-radius: 10px;
    /* background-color: rgb(229, 230, 247);     */
    /* font-size: 0.8em; */
    text-align: justify;
    /* border: 1px solid; */
    overflow: scroll;
    word-wrap: break-word;
}
.required-text{
        color:red; 
        font-weight:bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/uumm/AssignRegister.vue